import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {FinancialItemGLCodeLinkContainerModel} from '../../../../../../models/aggregates/erp/fi-item-glcode-link';


@Injectable({
  providedIn: 'root'
})
export class FinancialItemGLCodeLinkService extends BaseApiTemplateService<FinancialItemGLCodeLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  + 'item-company-glcode-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-company-glcode-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-company-glcode-links';
    this.httpClient = http;
  }
}
